import DeferredPayment from './deferred-payment.vue'
export default DeferredPayment
